enum ActionTypes {
  BIRTH_POSTERS_SET_PAGE_SIZE = 'BIRTH_POSTERS_SET_PAGE_SIZE',
  BIRTH_POSTERS_SET_ILLUSTRATIONS = 'BIRTH_POSTERS_SET_ILLUSTRATIONS',
}

export default ActionTypes;
